import React, { useEffect, useState } from "react";
import MarkdownSectionEditor from "../MarkdownSectionEditor";
import { getAuth } from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getFirestore, doc, setDoc, serverTimestamp, getDoc } from "firebase/firestore";




export default function AddEditNoteDialog({
  open,
  onClose,
  onSave
}: any) {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  

  const [image, setImage] = useState<File | null>(null);
  const [imageURL, setImageURL] = useState<string | null>(null);

  const hasText = text.trim().length > 0;
  const hasImage = !!imageURL;
  const isValid = hasText && hasImage;
  const path = window.location.pathname;
  const userId = path.split("/view/")[1];

  // ✅ Image upload
  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > 2 * 1024 * 1024) {
      alert("Max 2MB allowed");
      return;
    }

    setImage(file);
    setImageURL(URL.createObjectURL(file));
  };

  const handleSave = async () => {
    try {
      // 1. Debug log
      console.log("Saving data:", { text, image });
  
      // 2. Disable UI
      setLoading(true);
  
      const auth = getAuth();
  
      console.log("userrrrrr", userId)
  
  
      let imageUrl = imageURL;

      if (image) {
        const storage = getStorage();

        const filePath = `helperText/${userId}/${Date.now()}_${image.name}`;
        const imageRef = ref(storage, filePath);

        await uploadBytes(imageRef, image);
        imageUrl = await getDownloadURL(imageRef);
      }
  
      // 4. Save to Firestore (INSIDE USER DOC)
      const db = getFirestore();
  
      await setDoc(
        doc(db, "users", userId),
        {
          helperText: {
            text,
            image: imageUrl,
            updatedAt: serverTimestamp(),
          },
        },
        { merge: true } // 🔥 prevents overwriting whole doc
      );
  
      console.log("Saved successfully");
  
      // 5. Close dialog
      onClose();
  
    } catch (err: any) {
      console.error("Save failed:", err);
      alert(err?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!open || !userId) return;
  
    const fetchHelperText = async () => {
      try {
        const db = getFirestore();
        const snap = await getDoc(doc(db, "users", userId));
  
        if (snap.exists()) {
          const helper = snap.data().helperText;
  
          setText(helper?.text || "");
          setImageURL(helper?.image || null);
          setImage(null); // 🔥 important reset
        }
      } catch (err) {
        console.error("Fetch failed:", err);
      }
    };
  
    fetchHelperText();
  }, [userId, open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-[560px] rounded-xl bg-white p-6 shadow-xl">

        {/* Title */}
        <h2 className="mb-4 text-lg font-semibold">
          {imageURL ? "Edit note" : "Add note"}
        </h2>

        {/* IMAGE SECTION */}
        <div className="flex gap-4 mb-5">
          {/* Preview */}
          <div className="h-[200px] w-[250px] rounded-lg bg-gray-100 flex items-center justify-center overflow-hidden">
            {imageURL ? (
              <img src={imageURL} className="h-full w-full object-cover" />
            ) : (
              <span className="text-gray-400 text-xl">🖼️</span>
            )}
          </div>

          {/* Controls */}
          <div className="flex flex-col justify-center gap-2 text-sm">
            <div className="flex gap-2">
              <label className="cursor-pointer rounded border px-3 py-1 hover:bg-gray-50">
                {imageURL ? "Replace" : "Choose image"}
                <input
                  type="file"
                  accept="image/*"
                  disabled={loading}
                  onChange={handleUpload}
                  className="hidden"
                />
              </label>

              {imageURL && (
                <button
                  onClick={() => {
                    setImage(null);
                    setImageURL(null);
                  }}
                  className="rounded border px-3 py-1 text-red-500 hover:bg-red-50"
                >
                  Remove
                </button>
              )}
            </div>

            <p className="text-xs text-gray-500">
              Optional. Displayed above the note text. Max 2 MB, PNG or JPG.
            </p>
          </div>
        </div>

        {/* NOTE SECTION */}
        <div className="mb-1 text-sm font-medium">Note</div>
        <p className="text-xs text-gray-500 mb-2">
          This note will appear on the member's home page.
        </p>

        {/* Tabs */}
        <MarkdownSectionEditor
              initialMarkdown={text}
              readOnly={false} 
              onSave={(v: string) => setText(v)} // live update
              editorHeight="140px"
              title="title"
              showSaveButton={false}
        />
          

       

        {/* Character hint */}
        <p className="mt-1 text-xs text-gray-400">
          Up to 1,000 characters
        </p>

        {/* WARNING */}
        {!isValid && (
        <div className="mt-3 flex items-center gap-2 rounded-md bg-amber-100 px-3 py-2 text-sm text-amber-700">
          ⚠️ Please add both image and text to display this section on the member's profile
        </div>
      )}

        {/* ACTIONS */}
        <div className="mt-5 flex justify-end gap-3">
          <button
            onClick={() => {
              setText("");
              setImage(null);
              setImageURL(null);
              onClose();
            }} disabled={loading}
            className={`
              text-sm 
              ${loading ? "text-gray-400 cursor-not-allowed" : "text-gray-600 hover:text-black"}
            `}
            
          >
            Cancel
          </button>

          <button
            onClick={handleSave} disabled={loading}
            className={`
              rounded-md px-4 py-2 text-sm text-white
              ${loading 
                ? "bg-gray-400 cursor-not-allowed" 
                : "bg-indigo-600 hover:bg-indigo-700"}
            `}
          >
            Save
          </button>
        </div>

      </div>
    </div>
  );
}